module.exports = __webpack_public_path__ + "static/media/ring-line-2.bfd174d6.svg";